import React, { useRef, useState } from "react";
import status_moreIcon from "../../Assets/status_moreIcon.png";
import form_statusIcon from "../../Assets/form_statusIcon.png";
import caret_down from "../../Assets/caret-down.png";
import Addiconfontsizes from "../../Assets/Addiconfontsizes.png";
import reduceiconfontsizes from "../../Assets/reduceiconfontsizes.png";
import FormStatusModal from "./SettingModals/FormStatusModal";
import QuizError from "./SettingModals/QuizError";
import UnSavedModal from "./SettingModals/UnSavedModal";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { createNewForm } from "../../Redux/Reducer/FormSlices";

const GeneralSetting = () => {
  const dispatch = useDispatch();
  const [openFormStatus, setOpenFormStatus] = useState(false);
  const [openTextSize, setTextSize] = useState(false);

  const handelChangeStatus = () => {
    setOpenFormStatus(!openFormStatus);
  };

  // error modal for quiz
  const [openQuizError, setOpenQuizError] = useState(false);
  const handelQueizenError = () => {
    setOpenQuizError(!openQuizError);
  };

  const nevigate = useNavigate();

  const finputRefs = useRef(null);
  const sinputRefs = useRef(null);
  const tinputRefs = useRef(null);

  const handelActionButton = (value) => {
    console.log(value);
    if (value === "first") {
      finputRefs.current.focus();
    } else if (value === "secondary") {
      sinputRefs.current.focus();
    } else if (value === "last") {
      tinputRefs.current.focus();
    }
  };

  // unsaved changes warings modal
  const [unSavedWaringsModal, setUnSavedWaringsModal] = useState(false);
  const handleUnsavedChanges = () => {
    setUnSavedWaringsModal(!unSavedWaringsModal);
  };

  const formId = useParams().formId;
  //default settings
  const [formTitle, setFormTitle] = useState("");
  const defaultSettings = {
    formStatus: "enabled",
    disableOnDate: "",
    disableOnTime: "",
    responseLimit: "",
    ErrorMessage: "ErrorMessage",
    quizSettings: null,
    textSize: {
      formTitleSize: 10,
      questionTextSize: 10,
      answerTextSize: 10,
    },
  };

  const defaultQuizSettings = {
    releaseMarks: "AfterSubmission",
    questionPointValue: 5,
    showMissedQuestions: true,
    shuffleQuestions: true,
    showCorrectAnswers: true,
    showPointValues: true,
    showMarkEachSubmission: true,
    showMarkAfterManualReview: false,
  };

  //general settings values
  const [settings, setSettings] = useState(defaultSettings);

  const [isValidFormMakeQuiz, setIsValidFormMake] = useState(true);
  //get form settings
  useEffect(() => {
    const fetchFormSettings = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API}/forms/singleFormSettings/${formId}`
        );
        console.log(response.data);
        if (response.data.status) {
          setSettings(response.data.formSetting);
          setFormTitle(response.data.formTitle);
          setIsValidFormMake(response.data.formValiForQuiz);
          // setIsValidFormMake(false);
        }
      } catch (error) {
        console.error(error);
        setSettings(defaultSettings);
      }
    };
    fetchFormSettings();
  }, [formId]);

  const handelFormStatus = async () => {
    const generalSettingValue = {
      value: settings,
      type: "generalSetting",
    };
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API}/forms/singleFormSetting/${formId}`,
        generalSettingValue
      );
      if (response.status === 200) {
        handelChangeStatus();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handelSubmitGeneralSetting = async () => {
    const generalSettingValue = {
      value: settings,
      type: "generalSetting",
    };
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API}/forms/singleFormSetting/${formId}`,
        generalSettingValue
      );
      if (response.status === 200) {
        dispatch(createNewForm(response.data.formDetails));
        nevigate(`/create-form/${formId}/question`);
      }
    } catch (error) {
      console.error(error.message);
    }
  };
  //Get Form Status
  const getFormStatus = (value) => {
    if (value === "enabled" || value === "Enabled") {
      return "Enabled";
    } else if (value === "disabled" || value === "Disabled") {
      return "Disabled";
    } else if (
      value === "disableOnDate" ||
      value === "Disable on specific date"
    ) {
      return "Disable on specific date";
    } else if (
      value === "disableOnLimit" ||
      value === "Disable on response limit"
    ) {
      return "Disable on response limit";
    } else if (
      value === "disableOnDateAndLimit" ||
      value === "Disable on specific date and response limit"
    ) {
      return "Disable on specific date and response limit";
    }
  };

  //handleChangeQuiz
  const handleChangeQuiz = (e) => {
    const { value, name, checked, type } = e.target;
    if (name === "isQuiz") {
      if (isValidFormMakeQuiz) {
        setSettings((prevSettings) => ({
          ...prevSettings,
          isQuiz: checked,
          quizSettings: checked ? defaultQuizSettings : null,
        }));
      } else {
        setOpenQuizError(true);
      }
    } else if (name.startsWith("quizSettings.")) {
      const key = name.split(".")[1];
      setSettings((prevSettings) => ({
        ...prevSettings,
        quizSettings: {
          ...prevSettings.quizSettings,
          [key]: type === "checkbox" ? checked : value,
        },
      }));
    }
  };
  return (
    <>
      <FormStatusModal
        isOpen={openFormStatus}
        onClose={handelChangeStatus}
        settings={settings}
        setSettings={setSettings}
        save={handelFormStatus}
      />
      <QuizError
        isOpen={openQuizError}
        onClose={handelQueizenError}
        settings={settings}
      />

      <UnSavedModal
        isOpen={unSavedWaringsModal}
        onClose={handleUnsavedChanges}
        settings={settings}
      />
      <div className="general-setting-container">
        <div className="title-input-container-form">
          <p>Title</p>
          <input
            type="text"
            placeholder="Form Title"
            className="input-for-form-title"
            value={formTitle}
            onChange={(e) => setFormTitle(e.target.value)}
          />
          <div className="text-notification">Enter a name for your form</div>
        </div>
        <div className="form-status-container">
          <div className="form-status-text-container">
            <div className="status-head">Form status</div>
            <div className="status-des">
              Enable, disable, or conditionally enable your form
            </div>
          </div>
          <div className="status-dropdown-container">
            <div className="img-text-container-status">
              <img src={form_statusIcon} alt="form_statusIcon" />
              <div>
                <div>{getFormStatus(settings.formStatus)}</div>
                <div
                  style={{
                    fontSize: "0.75rem",
                    color: "rgba(132, 147, 178, 1)",
                  }}
                >
                  Your form is currently visible and able to receive response
                </div>
              </div>
            </div>
            <div onClick={handelChangeStatus}>
              <img src={status_moreIcon} alt="" />
            </div>
          </div>
        </div>
        <div className="encrypt-data-container">
          <div className="text-container-setting">
            <div className="text-head">Encrypt Form Data</div>
            <div className="text-des">
              Encrypt your form responses to store sensitive data securely.
              Learn more
            </div>
          </div>
          <div>
            <label className="form-setting-switch">
              <input type="checkbox" />
              <span className="form-setting-slider form-setting-round"></span>
            </label>
          </div>
        </div>
      </div>
      <div className="general-setting-container">
        <div className="encrypt-data-container">
          <div className="text-container-setting">
            <div className=".heading-mark-details">Make this a quiz</div>
            <div className="text-des">
              Assign point values, set answers and automatically provide
              feedback
            </div>
          </div>
          <div>
            <label className="form-setting-switch">
              <input
                type="checkbox"
                name="isQuiz"
                checked={settings.isQuiz}
                onChange={handleChangeQuiz}
              />
              <span className="form-setting-slider form-setting-round"></span>
            </label>
          </div>
        </div>
        {/* quiz container */}
        {settings.isQuiz && (
          <div className="quiz-container">
            <div className="action-mark-container">
              <div className="heading-mark-details">RELEASE MARKS</div>
              <div className="single-martk-option">
                {console.log(
                  settings.quizSettings.showMarkEachSubmission,
                  "quizSettings"
                )}
                <input
                  type="radio"
                  name="quizSettings.showMarkEachSubmission"
                  checked={settings.quizSettings.showMarkEachSubmission}
                  onChange={(e) =>
                    setSettings({
                      ...settings,
                      quizSettings: {
                        ...settings.quizSettings,
                        showMarkEachSubmission: true,
                        showMarkAfterManualReview: false,
                      },
                    })
                  }
                />
                <div>Immediately after each submission</div>
              </div>
              <div
                className="single-martk-option"
                style={{ alignItems: "start" }}
              >
                <input
                  type="radio"
                  style={{ marginTop: "7px" }}
                  name="quizSettings.showMarkAfterManualReview"
                  checked={settings.quizSettings.showMarkAfterManualReview}
                  onChange={(e) =>
                    setSettings({
                      ...settings,
                      quizSettings: {
                        ...settings.quizSettings,
                        showMarkEachSubmission: false,
                        showMarkAfterManualReview: true,
                      },
                    })
                  }
                />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "0.8rem",
                  }}
                >
                  <div>Later, after manual review</div>
                  <div className="support-text">
                    Turns on responses → collect email addresses
                  </div>
                </div>
              </div>
            </div>
            <div className="encrypt-data-container">
              <div className="text-container-setting">
                <div className=".heading-mark-details">
                  Default question point value
                </div>
                <div className="text-des">
                  Point values for every new question
                </div>
              </div>
              <div className="input-text-sizes">
                <input
                  type="number"
                  placeholder=""
                  name="quizSettings.questionPointValue"
                  className="inputValue-for-form-name"
                  value={settings.quizSettings.questionPointValue || ""}
                  onChange={handleChangeQuiz}
                />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                    justifyContent: "center",
                  }}
                >
                  <img src={Addiconfontsizes} alt="addicon" />
                  <img src={reduceiconfontsizes} alt="reduce" />
                </div>
                <div className="text-sizes-model">Points</div>
              </div>
            </div>
            <div className="encrypt-data-container">
              <div className="text-container-setting">
                <div className=".heading-mark-details">Missed questions</div>
                <div className="text-des">
                  Respondents can see which questions were answered incorrectly
                </div>
              </div>
              <div>
                <label className="form-setting-switch">
                  <input
                    type="checkbox"
                    name="quizSettings.showMissedQuestions"
                    checked={settings.quizSettings.showMissedQuestions}
                    onChange={handleChangeQuiz}
                  />
                  <span className="form-setting-slider form-setting-round"></span>
                </label>
              </div>
            </div>
            <div className="encrypt-data-container">
              <div className="text-container-setting">
                <div className=".heading-mark-details">
                  Shuffle question order
                </div>
                <div className="text-des">
                  Lorem Ipsum has been the industry's standard dummy text ever
                  since
                </div>
              </div>
              <div>
                <label className="form-setting-switch">
                  <input
                    type="checkbox"
                    name="quizSettings.shuffleQuestions"
                    checked={settings.quizSettings.shuffleQuestions}
                    onChange={handleChangeQuiz}
                  />
                  <span className="form-setting-slider form-setting-round"></span>
                </label>
              </div>
            </div>
            <div className="encrypt-data-container">
              <div className="text-container-setting">
                <div className=".heading-mark-details">Correct answers</div>
                <div className="text-des">
                  Respondents can see correct answers after grades are released{" "}
                </div>
              </div>
              <div>
                <label className="form-setting-switch">
                  <input
                    type="checkbox"
                    name="quizSettings.showCorrectAnswers"
                    checked={settings.quizSettings.showCorrectAnswers}
                    onChange={handleChangeQuiz}
                  />
                  <span className="form-setting-slider form-setting-round"></span>
                </label>
              </div>
            </div>
            <div className="encrypt-data-container">
              <div className="text-container-setting">
                <div className=".heading-mark-details">Point values</div>
                <div className="text-des">
                  Respondents can see total points and points received for each
                  question
                </div>
              </div>
              <div>
                {" "}
                <label className="form-setting-switch">
                  <input
                    type="checkbox"
                    name="quizSettings.showPointValues"
                    checked={settings.quizSettings.showPointValues}
                    onChange={handleChangeQuiz}
                  />
                  <span className="form-setting-slider form-setting-round"></span>
                </label>
              </div>
            </div>
          </div>
        )}
      </div>
      {/* <div className="general-setting-container">
        <div
          className="encrypt-data-container"
          onClick={() => setTextSize(!openTextSize)}
        >
          <div className="text-container-setting">
            <div className="text-head">Text size</div>
            <div className="text-des">
              It has textual features that allow it to alter the overall format
              of the text.
            </div>
          </div>
          <div>
            <img src={caret_down} alt="caret-down" />
          </div>
        </div>
        {openTextSize && (
          <>
            <div className="encrypt-data-container">
              <div className="text-container-setting">
                <div className="text-head">Heading size text</div>
                <div className="text-des">
                  This text denotes the heading of the form.
                </div>
              </div>
              <div
                className="input-text-sizes"
                onClick={() => handelActionButton("first")}
              >
                <div style={{ display: "flex", gap: "0.2rem" }}>
                  {console.log(settings.textSize.formTitleSize)}
                  <input
                    ref={finputRefs}
                    value={settings.textSize.formTitleSize || 10}
                    onChange={(e) =>
                      setSettings({
                        ...settings,
                        textSize: {
                          ...settings.textSize,
                          formTitleSize: e.target.value,
                        },
                      })
                    }
                    style={{ width: "20%" }}
                    className="text-size-setting-input"
                  />
                  <div>px</div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                    justifyContent: "center",
                  }}
                >
                  <img src={Addiconfontsizes} alt="addicon" />
                  <img src={reduceiconfontsizes} alt="reduce" />
                </div>
                <div className="text-sizes-model">Text Size</div>
              </div>
            </div>
            <div className="encrypt-data-container">
              <div className="text-container-setting">
                <div className="text-head">Question Body text</div>
                <div className="text-des">
                  This text denotes the question of the form.
                </div>
              </div>
              <div
                className="input-text-sizes"
                onClick={() => handelActionButton("secondary")}
              >
                <div style={{ display: "flex", gap: "0.2rem" }}>
                  <input
                    ref={sinputRefs}
                    value={settings.textSize.questionTextSize}
                    onChange={(e) =>
                      setSettings({
                        ...settings,
                        textSize: {
                          ...settings.textSize,
                          questionTextSize: e.target.value,
                        },
                      })
                    }
                    style={{ width: "20%" }}
                    className="text-size-setting-input"
                  />
                  <div>px</div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                    justifyContent: "center",
                  }}
                >
                  <img src={Addiconfontsizes} alt="addicon" />
                  <img src={reduceiconfontsizes} alt="reduce" />
                </div>
                <div className="text-sizes-model">Text Size</div>
              </div>
            </div>
            <div className="encrypt-data-container">
              <div className="text-container-setting">
                <div className="text-head">Answer Body text</div>
                <div className="text-des">
                  This text denotes the answer of the form.
                </div>
              </div>
              <div
                className="input-text-sizes"
                onClick={() => handelActionButton("last")}
              >
                <div style={{ display: "flex", gap: "0.2rem" }}>
                  <input
                    ref={tinputRefs}
                    value={settings.textSize.answerTextSize}
                    onChange={(e) =>
                      setSettings({
                        ...settings,
                        textSize: {
                          ...settings.textSize,
                          answerTextSize: e.target.value,
                        },
                      })
                    }
                    style={{ width: "20%" }}
                    className="text-size-setting-input"
                  />
                  <div>px</div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                    justifyContent: "center",
                  }}
                >
                  <img src={Addiconfontsizes} alt="addicon" />
                  <img src={reduceiconfontsizes} alt="reduce" />
                </div>
                <div className="text-sizes-model">Text Size</div>
              </div>
            </div>
          </>
        )}
      </div> */}  
      <hr />
      <div className="save-btn-container-general-setting">
        <button onClick={handelSubmitGeneralSetting}>Save</button>
      </div>
    </>
  );
};

export default GeneralSetting;
